
export const getPasteFailureMessage = (error: unknown): string => {
  const message = `${(error as { message?: string })?.message || error || ""}`

  if (
    /Cannot read properties of undefined \(reading 'fieldTypes'\)/i.test(
      message
    ) ||
    /Source block not found/i.test(message) ||
    /Block with ID .* not found/i.test(message)
  ) {
    return "The copied block is no longer available. Copy a block again and retry."
  }

  return message || "Unable to paste copied block."
}
